
import { TbPhoneCall } from "react-icons/tb";
import { FaXTwitter, FaLinkedinIn, FaFacebookF } from "react-icons/fa6";
import { MdOutlineMailOutline } from "react-icons/md";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <h2>Lenpec Global Concept Ltd</h2>
          <p>
            Reliable procurement <br />
            since 2006.
          </p>
        </div>

        {/* DISCOVER */}
        <div className="footer-col">
          <h4>Discover</h4>
          <ul>
            <li>About Us</li>
            <li>Services</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* INFO */}
        <div className="footer-col">
          <h4>Info</h4>
          <ul>
            <li className="phoneicon"><TbPhoneCall /> +2349062208197</li>
            <li className="phoneicon"><MdOutlineMailOutline /> info@lenpecgc.com</li>
          </ul>

        </div>

        {/* NEWSLETTER */}
        <div className="footer-newsletter">
          <h4>Address.</h4>
          <p>
            The Choice Place
            227 Aboluma Road
            Port Harcourt,
            Rivers State, Nigeria.
          </p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p>
          © Lenpec Global Concept Limited. All Rights Reserved.
        </p>

        <div className="footer-socials">
          <FaXTwitter />
          <FaLinkedinIn />
          <FaFacebookF />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
